<template>
  <div>
    <v-dialog
      v-model="dialog"
      :max-width="options.width"
      :style="{ zIndex: options.zIndex }"
      @keydown.esc="cancel"
    >
      <v-card class="px-12 py-8" flat>
        <v-row>
          <v-col class="py-0" cols="12" sm="12" md="12">
            <p class="caption font-weight-bold align mb-2">Import Tool</p>
            <v-row no-gutters>
              <v-col class="pa-0" cols="12" md="12" sm="12">
                <v-file-input
                  v-model="tenantFile"
                  accept=".csv"
                  label="Click here to upload PDCs"
                  prepend-icon=""
                  chips
                  small-chips
                  outlined
                  dense
                  hide-details
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-btn @click="uploadTenantImportFile">Upload</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarMessage }}
      <v-btn text color="primary" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ['reloadData'],
  data() {
    return {
      dialog: false,
      options: {
        color: 'primary',
        width: 500,
        zIndex: 200
      },
      tenantFile: null,
      snackbar: false,
      snackbarMessage: ''
    }
  },
  methods: {
    open() {
      this.dialog = true
    },
    async uploadTenantImportFile() {
      this.$root.$setLoading(true)
      await this.$store.dispatch('pdcs/uploadPDCImportFile', {
        file: this.tenantFile
      })
      this.snackbar = true
      this.snackbarMessage = 'Tenant file uploaded'
      this.$root.$setLoading(false)
      this.dialog = false
      this.reloadData()
    }
  }
}
</script>
